import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6cc4bbf6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["src"];

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "个性定制", -1);
});

var _hoisted_3 = {
  style: {
    "margin": "16px"
  }
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提 交 定 制 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_field = _resolveComponent("van-field");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_form = _resolveComponent("van-form");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("header", null, [_createElementVNode("img", {
    src: require('@/assets/images/order_big_tg.png'),
    style: {
      "width": "0.5rem"
    }
  }, null, 8, _hoisted_1), _hoisted_2]), _createVNode(_component_van_form, {
    onSubmit: $options.submitCustomize
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: $data.customize.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $data.customize.name = $event;
            }),
            name: "姓名",
            label: "姓名",
            placeholder: "请填写您的姓名",
            rules: [{
              required: true,
              message: '请填写姓名'
            }],
            required: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: $data.customize.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $data.customize.phone = $event;
            }),
            type: "tel",
            name: "联系电话",
            label: "联系电话",
            placeholder: "请填写您的联系电话",
            rules: [{
              required: true,
              message: '请填写联系电话'
            }],
            required: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: $data.customize.request,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return $data.customize.request = $event;
            }),
            rows: "3",
            autosize: "",
            label: "定制要求",
            type: "textarea",
            maxlength: "120",
            placeholder: "我想要定制杭州联通中间四位是0571的号码",
            "show-word-limit": "",
            rules: [{
              required: true,
              message: '请填写定制要求'
            }],
            required: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        "native-type": "submit",
        disabled: $data.btnDisabled
      }, {
        default: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      }, 8, ["disabled"])])];
    }),
    _: 1
  }, 8, ["onSubmit"])]);
}